<shared-badge
  [class]="'badge badge-pill badge-info'"
  [label]="label"
  [tooltip]="tooltip"
>
</shared-badge>
